import { CART_CHECKOUT_MINIMUM } from 'modules/cart/constants'

/**
 * @param props
 * @param props.subtotal
 * @returns {boolean}
 */
const hasReachedCheckoutMinimumCartSelectUtil = (props) => {
  const {
    subtotal
  } = props

  return (
    subtotal >= CART_CHECKOUT_MINIMUM
  )
}

export default hasReachedCheckoutMinimumCartSelectUtil
